var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "modal-title" }, [_vm._v("Layer Access Page")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "menu-row-access-application" },
      [
        _c(
          "b-row",
          { staticClass: "pr-2" },
          [
            _c("b-col", { staticClass: "d-flex", attrs: { cols: "5" } }, [
              _c("img", {
                staticClass: "m__t--5",
                attrs: {
                  src: _vm.selectedPages.icon_grey,
                  height: "16",
                  width: "16"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [
                _c("div", { staticClass: "page-name" }, [
                  _vm._v(_vm._s(_vm.selectedPages.name.toUpperCase()))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "page-id" }, [
                  _vm._v(_vm._s(_vm.selectedPages.id))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { staticClass: "border-left", attrs: { cols: "6" } }, [
              _c("div", { staticClass: "page-type" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.selectedPages.type === "visible"
                        ? "VISIBLE AT MENU"
                        : "MENU TITLE"
                    ) +
                    " "
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "wrap-config" }, [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center",
          staticStyle: { "padding-right": "38px" }
        },
        [
          _c("p", { staticClass: "title m-0" }, [
            _vm._v(" Config Security Pages ")
          ]),
          _vm._v(" "),
          _c("j-toggle", {
            staticStyle: { height: "20px" },
            model: {
              value: _vm.useConfig,
              callback: function($$v) {
                _vm.useConfig = $$v
              },
              expression: "useConfig"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.useConfig
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "session-access" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Security Type ")]),
                          _vm._v(" "),
                          _c("b-form-radio-group", {
                            staticClass: "jFormGroup",
                            attrs: { options: _vm.listSecurityType },
                            model: {
                              value: _vm.dataSetup.security_type,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "security_type", $$v)
                              },
                              expression: "dataSetup.security_type"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.dataSetup.security_type === "otp"
                ? _c(
                    "div",
                    { staticClass: "session-access" },
                    [
                      _c("p", { staticClass: "section-title mb-2" }, [
                        _vm._v("Verification OTP Method")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "otp-verification" },
                        _vm._l(_vm.verificationOTP, function(otp) {
                          return _c(
                            "div",
                            {
                              key: otp.key,
                              staticClass: "otp-verification-list",
                              class: {
                                active: _vm.dataSetup.otp_method === otp.key
                              },
                              on: {
                                click: function($event) {
                                  _vm.setSelectedOtpMethod(otp.key)
                                }
                              }
                            },
                            [
                              _c("p", [_vm._v(_vm._s(otp.name))]),
                              _vm._v(" "),
                              otp.desc
                                ? _c("span", [_vm._v(_vm._s(otp.desc))])
                                : _vm._e()
                            ]
                          )
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "session-access" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _vm.dataSetup.otp_method === "function"
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "mb-1 mr-2" },
                                        [_vm._v(" Function ")]
                                      ),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          options: _vm.listFunction,
                                          placeholder: "Select Function",
                                          label: "name"
                                        },
                                        model: {
                                          value: _vm.functionPages,
                                          callback: function($$v) {
                                            _vm.functionPages = $$v
                                          },
                                          expression: "functionPages"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "7" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", { staticClass: "mb-1 mr-2" }, [
                                    _vm._v(" OTP Session Access ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.otpSessionAccess,
                                      placeholder: "Select otp session"
                                    },
                                    model: {
                                      value: _vm.dataSetup.otp_session,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "otp_session",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.otp_session"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "5" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", { staticClass: "mb-1 mr-2" }, [
                                    _vm._v(" Standby Session Access ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.standbySessionAccess,
                                      placeholder: "Select standby session"
                                    },
                                    model: {
                                      value: _vm.dataSetup.standby_session,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "standby_session",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.standby_session"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataSetup.security_type === "password"
                ? _c(
                    "div",
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", { staticClass: "mb-1 mr-2" }, [
                                    _vm._v(" Standby Session Access ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.standbySessionAccess,
                                      placeholder: "Select standby session"
                                    },
                                    model: {
                                      value: _vm.dataSetup.standby_session,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "standby_session",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.standby_session"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "float-right m__t--10" },
      [
        _c(
          "b-button",
          { staticClass: "btn m__r--5", on: { click: _vm.closeModal } },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "b-button",
          { staticClass: "btn blue", on: { click: _vm.submitConfig } },
          [_vm._v("\n      Save\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information" }, [
      _c("img", { attrs: { src: require("@/assets/icon/info.svg") } }),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("Information")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "If you implement security type password on layer access page, users will be required to enter their own password before accessing the page."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51cb3d39", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51cb3d39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/access/components/jPopupSecurityPage.vue
// module id = null
// module chunks = 